import {
  IonContent,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonPopover,
  IonRouterLink,
  NavContext,
  useIonPopover,
  useIonViewWillLeave,
} from "@ionic/react";
import {
  calendar,
  calendarOutline,
  desktop,
  desktopOutline,
  home,
  person,
  personCircle,
  personOutline,
  documentOutline,
  pricetag,
  trashOutline,
  closeCircleOutline,
} from "ionicons/icons";
import React, {
  createRef,
  MouseEvent,
  ReactNode,
  Ref,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  GlobalStateProvider,
  useGlobalState,
  GlobalStateInterface,
} from "./../GlobalStateProvider";

import { Storage } from "@ionic/storage";
import Button from "./Ebert/Button";
import { PopoverDismiss } from "./Common";



function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

type Props = {
  page?: "Strona główna" | "Nasze kursy" | "Korepetycje" | undefined;
}

const CustomerHeaderDesktop: React.FC<Props> = ({ page }) => {
  const { navigate } = useContext(NavContext);

  const _Popover: React.FC<{
    onHide: () => void;
  }> = ({ onHide }) => (
    <IonContent>
      <IonItem
        lines="full"
        style={{
          "--background": "#f2fbfb",
          borderTop: "3px solid var(--ion-color-primary)",
          borderRadius: "5px 5px 0 0",
        }}
      >
        <IonIcon
          color="secondary"
          style={{
            width: "40px",
            height: "40px",
            marginRight: "16px",
          }}
          slot="start"
          src={personCircle}
        ></IonIcon>
        <IonLabel color="secondary">
          <h2
            style={{
              fontWeight: 600,
            }}
          >
            Mateusz Ebert
          </h2>
          <h3>mateusz@ebert.app</h3>
        </IonLabel>
      </IonItem>

      <IonList
        lines="none"
        style={{
          padding: "9px 6px 0px",
          borderBottom: "1px solid",
          borderColor:
            "var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))",
        }}
      >
        <IonItem
          onClick={() => {
            navigate("/profile/data", "forward", "push");
            onHide();
          }}
          button
        >
          <IonLabel>Profil</IonLabel>
          <IonIcon slot="start" icon={personOutline} />
        </IonItem>
        <IonItem
          onClick={() => {
            navigate("/profile/courses", "forward", "push");
            onHide();
          }}
          button
        >
          <IonLabel>Kursy</IonLabel>
          <IonIcon slot="start" icon={desktopOutline} />
        </IonItem>
        <IonItem
          onClick={() => {
            navigate("/profile/corepetition", "forward", "push");
            onHide();
          }}
          button
        >
          <IonLabel>Korepetycje</IonLabel>
          <IonIcon slot="start" icon={calendarOutline} />
        </IonItem>
        <IonItem
          onClick={() => {
            navigate("/profile/notes", "forward", "push");
            onHide();
          }}
          button
        >
          <IonLabel>Notatki</IonLabel>
          <IonIcon slot="start" icon={documentOutline} />
        </IonItem>
        <IonItemDivider style={{ minHeight: "1px" }} className="mt-1 mb-1" />
        <Button
          className="mt-0"
        onClick={async () => {
          setState((prev) => ({
            ...prev,
            ...{ token: undefined, logged: false, firstname: "", lastname: "" },
          }));
          onHide();

          await storage.create();
          await storage.remove("token");
        }}
        style={{ width: "100%", padding: "4px 10px", fontWeight: "600" }}
        color="danger"
        label="Wyloguj"
        fill="clear"
      />
      </IonList>

      
    </IonContent>
  );

  const [present, dismiss] = useIonPopover(_Popover, {
    onHide: () => dismiss(),
  });

  const _PopoverCart: React.FC<{
    onHide: () => void;
  }> = ({ onHide }) => (
    <IonContent>
      <IonList
        lines="none"
        style={{
          padding: "9px 6px 0px",
          borderBottom: "1px solid",
          borderColor:
            "var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))",
        }}
      >

        {state.cart?.map((e, i) => {
          return (
            <IonItem>
              <div className="p-2 flex-md-row align-items-center row position-relative">
                <IonIcon
                  onClick={() => {
                    setTimeout(() => {
                      if (state.cart) {
                        let tempCart = state.cart;
                        tempCart.splice(i, 1);
                        setState((prev) => ({
                          ...prev,
                          ...{ cart: tempCart },
                        }));
                      }
                    }, 100);
                  }}
                  id={"remove-cart-" + i}
                  color="danger"
                  style={{
                    marginLeft: "5px",
                    fontSize: "25px",
                    position: "absolute",
                    width: "25px",
                    right: "0",
                    top: "4px",
                    cursor: "pointer",
                    zIndex: 1,
                  }}
                  src={closeCircleOutline}
                />
                <div className="col-md-12 card-footer px-2 px-md-5 py-4 py-md-0 position-relative">
                  <div className="row">
                    <div className="col-auto">
                      <a>
                        <span className="mb-0 d-inline-block text-gray-800">
                          {e.category}
                        </span>
                      </a>
                    </div>
                  </div>
                  <div className="position-relative">
                    <a className="d-block stretched-link">
                      <h4 className="me-md-6 me-lg-10 me-xl-4 mb-2">
                        {/* Trygonometria - pojedynczy dział */}
                        {e.name}
                      </h4>
                    </a>
                    <ul className="nav mx-n3 mb-3">
                      <li className="nav-item px-3">
                        <div className="d-flex align-items-center">
                          <div className="me-2 d-flex text-secondary icon-uxs">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.1947 7.06802L14.6315 7.9985C14.2476 7.31186 13.712 6.71921 13.0544 6.25992C12.8525 6.11877 12.6421 5.99365 12.4252 5.88303C13.0586 5.25955 13.452 4.39255 13.452 3.43521C13.452 1.54098 11.9124 -1.90735e-06 10.0197 -1.90735e-06C8.12714 -1.90735e-06 6.58738 1.54098 6.58738 3.43521C6.58738 4.39255 6.98075 5.25955 7.61414 5.88303C7.39731 5.99365 7.1869 6.11877 6.98502 6.25992C6.32752 6.71921 5.79178 7.31186 5.40787 7.9985L2.8447 7.06802C2.33612 6.88339 1.79688 7.26044 1.79688 7.80243V16.5178C1.79688 16.8465 2.00256 17.14 2.31155 17.2522L9.75312 19.9536C9.93073 20.018 10.1227 20.0128 10.2863 19.9536L17.7278 17.2522C18.0368 17.14 18.2425 16.8465 18.2425 16.5178V7.80243C18.2425 7.26135 17.704 6.88309 17.1947 7.06802ZM10.0197 1.5625C11.0507 1.5625 11.8895 2.40265 11.8895 3.43521C11.8895 4.46777 11.0507 5.30792 10.0197 5.30792C8.98866 5.30792 8.14988 4.46777 8.14988 3.43521C8.14988 2.40265 8.98866 1.5625 10.0197 1.5625ZM9.23844 18.1044L3.35938 15.9703V8.91724L9.23844 11.0513V18.1044ZM10.0197 9.67255L6.90644 8.54248C7.58164 7.51892 8.75184 6.87042 10.0197 6.87042C11.2875 6.87042 12.4577 7.51892 13.1329 8.54248L10.0197 9.67255ZM16.68 15.9703L10.8009 18.1044V11.0513L16.68 8.91724V15.9703Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <div className="font-size-sm">3 lekcje</div>
                        </div>
                      </li>
                      <li className="nav-item px-3">
                        <div className="d-flex align-items-center">
                          <div className="me-2 d-flex text-secondary icon-uxs">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.3164 4.20996C13.985 4.37028 13.8464 4.76904 14.0067 5.10026C14.4447 6.00505 14.6667 6.98031 14.6667 8C14.6667 11.6759 11.6759 14.6667 8 14.6667C4.32406 14.6667 1.33333 11.6759 1.33333 8C1.33333 4.32406 4.32406 1.33333 8 1.33333C9.52328 1.33333 10.9543 1.83073 12.1387 2.77165C12.4259 3.00098 12.846 2.95296 13.0754 2.66471C13.3047 2.37663 13.2567 1.95703 12.9683 1.72803C11.5661 0.613607 9.8016 0 8 0C3.58903 0 0 3.58903 0 8C0 12.411 3.58903 16 8 16C12.411 16 16 12.411 16 8C16 6.77767 15.7331 5.60628 15.2067 4.51969C15.0467 4.18766 14.6466 4.04932 14.3164 4.20996Z"
                                fill="currentColor"
                              />
                              <path
                                d="M7.99967 2.66663C7.63167 2.66663 7.33301 2.96529 7.33301 3.33329V7.99996C7.33301 8.36796 7.63167 8.66663 7.99967 8.66663H11.333C11.701 8.66663 11.9997 8.36796 11.9997 7.99996C11.9997 7.63196 11.701 7.33329 11.333 7.33329H8.66634V3.33329C8.66634 2.96529 8.36768 2.66663 7.99967 2.66663Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <div className="font-size-sm">3h 12m</div>
                        </div>
                      </li>
                      <li className="nav-item px-3">
                        <div className="d-flex align-items-center">
                          <div className="me-2 d-flex text-secondary icon-uxs">
                            <IonIcon color="secondary" src={pricetag} />
                          </div>
                          <div
                            className="font-size-sm"
                            style={{
                              fontWeight: "700",
                              color: "var(--ion-color-secondary)",
                            }}
                          >
                            399,00 zł
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </IonItem>
          );
        })}

        {!Array.isArray(state.cart) || !state.cart.length ? (
          <h4
            style={{
              marginBottom: "25px",
              marginTop: "15px",
              textAlign: "center",
              color: "var(--ion-color-medium)",
            }}
          >
            Brak kursów w koszyku
          </h4>
        ) : (
          <>
            <IonItemDivider style={{ minHeight: "1px" }} />
            <IonItem style={{ "--min-height": "0" }}>
              <IonLabel
                color="secondary"
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  marginBottom: 0,
                  fontSize: "18px",
                }}
              >
                Razem do zapłaty
              </IonLabel>
            </IonItem>
            <IonItem style={{ "--min-height": "0" }}>
              <IonLabel
                color="secondary"
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  marginTop: 0,
                  fontSize: "19px",
                }}
              >
                <strong>100,00 zł</strong>
              </IonLabel>
            </IonItem>
            <IonItemDivider style={{ minHeight: "1px" }} />
            <Button
              fontSize={19}
              onClick={async () => {
                navigate("/cart", "forward", "push");
                onHide();
              }}
              style={{
                width: "100%",
                padding: "4px 10px",
                fontWeight: "600",
                margin: "7px 0",
              }}
              color="sucess"
              label="Przejdź do koszyka"
              fill="clear"
            />
          </>
        )}
      </IonList>
    </IonContent>
  );

  const [presentCart, dismissCart] = useIonPopover(_PopoverCart, {
    onHide: () => dismissCart(),
  });

  const { state } = useGlobalState();
  const storage = new Storage();

  const { setState } = useGlobalState();
  const ionPopoverRef = useRef<HTMLIonPopoverElement>(null);

  const [popoverTrigger, setPopoverTrigger] = useState<string>("");
  const [popoverCartTrigger, setPopoverCartTrigger] = useState<string>("");

  useEffect(() => {
    setPopoverTrigger(generateUUID());
    setPopoverCartTrigger(generateUUID());
  }, []);

  type PagesProps = {
    name: string;
    link: string;
  }

  const pages: PagesProps[] = [
    {
      name: "Strona główna",
      link: "/"
    },
    {
      name: "Nasze kursy",
      link: "/List"
    },
    {
      name: "Korepetycje",
      link: "/Corepetitions"
    },
  ]

  return (
    <header
      className="navbar navbar-expand-xl navbar-light"
      style={{
        padding: 0,
      }}
    >
      <div className="container container-wd">
        {/* Brand */}
        <IonRouterLink routerLink="/">
          <a className="navbar-brand">
            <img
              style={{
                width: "315px",
              }}
              src="./assets/img/brand-gigas.svg"
              className="navbar-brand-img"
              alt="..."
            />
          </a>
        </IonRouterLink>
        {/* Vertical Menu */}

        {/* Collapse */}
        <div
          className="collapse navbar-collapse z-index-lg"
          id="navbarCollapse"
        >
          {/* Toggler */}
          <button
            className="navbar-toggler outline-0 text-primary"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            {/* Icon */}
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.142135 2.00015L1.55635 0.585938L15.6985 14.7281L14.2843 16.1423L0.142135 2.00015Z"
                fill="currentColor"
              />
              <path
                d="M14.1421 1.0001L15.5563 2.41431L1.41421 16.5564L0 15.1422L14.1421 1.0001Z"
                fill="currentColor"
              />
            </svg>
          </button>
          {/* Navigation */}
          <ul className="navbar-nav ms-auto">
            
            {
              pages.map((e) => {
                return (
                  <li className="nav-item">
                    <IonRouterLink routerLink={e.link}>
                      <a
                        className={"nav-link px-xl-4 "}
                        id="navbarLandings"
                        style={{
                          fontSize: "19px",
                        }}
                      >
                        {e.name == page ? <strong>{e.name}</strong> : e.name}
                      </a>
                    </IonRouterLink>
                  </li>
                );
              })
            }
          </ul>
        </div>
        {/* Search, Account & Cart */}
        <ul className="navbar-nav flex-row ms-n4 ms-sm-auto ms-xl-0 me-n2 me-md-n4">
          <li className="nav-item border-0 px-1 px-md-3">
            {/* Button trigger cart modal */}
            <IonRouterLink
              id="popover-cart-click"
              onClick={(e) => {
                presentCart({
                  trigger: popoverCartTrigger,
                  triggerAction: "click",
                  showBackdrop: false,
                  reference: "trigger",
                  side: "bottom",
                  cssClass: "popoverCart popover1",
                  onWillPresent: (presentEvent) => {

                    PopoverDismiss(presentEvent);

                  }

                });
              }}
              // routerLink={
              //   state.logged
              //     ? undefined
              //     : "/cart"
              // }
            >
              <a
                id={popoverCartTrigger}
                className="nav-link d-flex bg-white-all rounded-circle position-relative icon-xs shadow-basic"
                data-bs-toggle="modal"
                data-bs-target="#cartModal"
                style={{
                  padding: "13.5px",
                }}
              >
                {!Array.isArray(state.cart) || !state.cart.length ? (
                  <></>
                ) : (
                  <span
                    className="badge text-white rounded-circle fw-bold badge-float mt-n4 ms-n4 px-0 w-16 right-0"
                    style={{
                      fontSize: 10,
                      background: "var(--ion-color-primary)",
                      width: "18px",
                    }}
                  >
                    {state.cart.length}
                  </span>
                )}

                {/* Icon */}
                <svg
                  width={15}
                  height={17}
                  viewBox="0 0 13 15"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.2422 3.51562H10.4567C10.2239 1.53873 8.53839 0 6.5 0C4.46161 0 2.7761 1.53873 2.54334 3.51562H0.757812C0.434199 3.51562 0.171875 3.77795 0.171875 4.10156V14.4141C0.171875 14.7377 0.434199 15 0.757812 15H12.2422C12.5658 15 12.8281 14.7377 12.8281 14.4141V4.10156C12.8281 3.77795 12.5658 3.51562 12.2422 3.51562ZM6.5 1.17188C7.89113 1.17188 9.04939 2.18716 9.27321 3.51562H3.72679C3.95062 2.18716 5.10887 1.17188 6.5 1.17188ZM11.6562 13.8281H1.34375V4.6875H2.51562V6.44531C2.51562 6.76893 2.77795 7.03125 3.10156 7.03125C3.42518 7.03125 3.6875 6.76893 3.6875 6.44531V4.6875H9.3125V6.44531C9.3125 6.76893 9.57482 7.03125 9.89844 7.03125C10.2221 7.03125 10.4844 6.76893 10.4844 6.44531V4.6875H11.6562V13.8281Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </IonRouterLink>
          </li>

          <li className="nav-item border-0 px-1 px-md-3">
            {/* Button trigger account modal */}
            <IonRouterLink
              onClick={(e) => {
                // if(state.logged)
                // {
                //   setShowPopover({ showPopover: true, event: undefined });
                // }

                if (state.logged) {
                  present({
                    trigger: popoverTrigger,
                    triggerAction: "click",
                    showBackdrop: false,
                    reference: "trigger",
                    side: "bottom",
                    cssClass: "popoverUser popover1",
                    onWillPresent: (presentEvent) => {

                      PopoverDismiss(presentEvent);
  
                    }
                  });
                }
              }}
              routerLink={state.logged ? undefined : "/login"}
            >
              <a
                id={popoverTrigger}
                className="nav-link d-flex p-3 bg-white-all icon-xs shadow-basic"
                style={{
                  borderRadius: "22px",
                  pointerEvents: state.logged ? "auto" : "none",
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    textTransform: "uppercase",
                    fontWeight: 700,
                    marginRight: 10,
                    marginLeft: 6,
                    lineHeight: "23px",
                  }}
                >
                  {state.firstname
                    ? state.firstname
                    : "Logowanie / rejestracja"}
                </div>

                {/* Icon */}
                <svg
                  width={22}
                  height={22}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2252 3.0777C15.3376 1.10738 12.7258 -0.0045765 9.99712 0.000444175C4.48284 -0.00650109 0.00695317 4.45809 7.91636e-06 9.97242C-0.00342287 12.6991 1.1084 15.3085 3.07726 17.1948C3.08299 17.2005 3.08512 17.209 3.09082 17.2141C3.14864 17.2698 3.21148 17.3169 3.27005 17.3705C3.43071 17.5133 3.59138 17.6611 3.76061 17.7989C3.85128 17.8703 3.94554 17.9417 4.03838 18.0074C4.19833 18.1266 4.35828 18.2459 4.52535 18.3558C4.6389 18.4273 4.756 18.4986 4.87236 18.5701C5.02658 18.6629 5.18012 18.7564 5.33936 18.8414C5.47434 18.9128 5.61211 18.9742 5.74922 19.0392C5.89917 19.1106 6.04698 19.182 6.20049 19.2462C6.354 19.3105 6.50826 19.3605 6.6639 19.4162C6.81954 19.4719 6.9538 19.5233 7.10304 19.569C7.27157 19.6197 7.44436 19.6589 7.61573 19.7011C7.75853 19.736 7.89706 19.776 8.04416 19.8046C8.24123 19.8439 8.44117 19.8689 8.64112 19.896C8.76467 19.9132 8.88534 19.9374 9.01027 19.9496C9.33732 19.9817 9.66718 19.9996 9.99992 19.9996C10.3327 19.9996 10.6626 19.9817 10.9896 19.9496C11.1146 19.9374 11.2352 19.9132 11.3587 19.896C11.5587 19.8689 11.7586 19.8439 11.9557 19.8046C12.0985 19.776 12.2413 19.7332 12.3841 19.7011C12.5555 19.6589 12.7283 19.6196 12.8968 19.569C13.046 19.5233 13.1903 19.4676 13.3359 19.4162C13.4816 19.3648 13.6473 19.3091 13.7994 19.2462C13.9514 19.1834 14.1007 19.1098 14.2506 19.0392C14.3877 18.9742 14.5256 18.9128 14.6605 18.8414C14.8197 18.7564 14.9732 18.6629 15.1275 18.5701C15.2439 18.4986 15.361 18.4337 15.4745 18.3558C15.6416 18.2459 15.8016 18.1267 15.9615 18.0074C16.0543 17.936 16.1485 17.8717 16.2392 17.7989C16.4085 17.6632 16.5691 17.519 16.7298 17.3705C16.7883 17.3169 16.8512 17.2698 16.909 17.2141C16.9147 17.2091 16.9169 17.2005 16.9226 17.1948C20.9046 13.38 21.04 7.05955 17.2252 3.0777ZM15.6203 16.4472C15.4904 16.5614 15.3561 16.6699 15.2205 16.7749C15.1405 16.8363 15.0605 16.897 14.9784 16.9556C14.8491 17.0491 14.7178 17.1377 14.5842 17.2226C14.4871 17.2848 14.3879 17.3447 14.2879 17.4033C14.1622 17.4747 14.0344 17.5461 13.9051 17.6175C13.7909 17.676 13.6745 17.7311 13.5574 17.7853C13.4403 17.8396 13.3111 17.8974 13.1847 17.9481C13.0583 17.9988 12.924 18.0467 12.7919 18.0909C12.6713 18.1323 12.5506 18.1752 12.4285 18.2116C12.2857 18.2544 12.1364 18.2894 11.9886 18.3251C11.8729 18.3522 11.7587 18.383 11.6416 18.4058C11.4724 18.4387 11.2996 18.4615 11.1261 18.4851C11.0275 18.4979 10.9297 18.5158 10.8304 18.5258C10.5562 18.5522 10.2784 18.5679 9.99783 18.5679C9.71722 18.5679 9.43945 18.5522 9.16524 18.5258C9.066 18.5158 8.96818 18.4979 8.8696 18.4851C8.6961 18.4615 8.5233 18.4387 8.35406 18.4058C8.23696 18.383 8.1227 18.3523 8.00705 18.3251C7.85924 18.2894 7.71213 18.2537 7.5672 18.2116C7.44512 18.1752 7.32441 18.1323 7.20375 18.0909C7.07166 18.0452 6.93953 17.9988 6.811 17.9481C6.68248 17.8974 6.5611 17.8417 6.43826 17.7853C6.31542 17.7289 6.20476 17.6761 6.09054 17.6175C5.9613 17.5504 5.83348 17.4797 5.7078 17.4033C5.60784 17.3448 5.50856 17.2848 5.41145 17.2226C5.27794 17.1377 5.14653 17.0491 5.01729 16.9556C4.93516 16.897 4.8552 16.8363 4.77521 16.7749C4.63952 16.6699 4.5053 16.5607 4.37535 16.4472C4.34393 16.4236 4.31536 16.3936 4.28469 16.3664C4.31661 13.9374 5.87708 11.7926 8.17843 11.0146C9.32912 11.562 10.6651 11.562 11.8158 11.0146C14.1171 11.7926 15.6776 13.9374 15.7096 16.3664C15.6796 16.3936 15.651 16.4208 15.6203 16.4472ZM7.50716 5.7256C8.2803 4.3506 10.0217 3.86272 11.3967 4.63586C12.7717 5.409 13.2596 7.15038 12.4864 8.52538C12.2299 8.98159 11.8529 9.35856 11.3967 9.61511C11.3931 9.61511 11.3888 9.61511 11.3845 9.61938C11.1952 9.72477 10.9951 9.80954 10.7876 9.87217C10.7505 9.88288 10.7162 9.89715 10.6769 9.90644C10.6055 9.92501 10.5305 9.93786 10.457 9.9507C10.3185 9.97493 10.1784 9.98898 10.0378 9.99283H9.95641C9.81588 9.98898 9.67576 9.97493 9.53727 9.9507C9.46585 9.93786 9.39016 9.92501 9.31736 9.90644C9.2795 9.89715 9.24594 9.88288 9.2067 9.87217C8.99922 9.80954 8.79911 9.72481 8.60974 9.61938L8.5969 9.61511C7.2219 8.84197 6.73402 7.10059 7.50716 5.7256ZM16.9763 14.9505C16.518 12.8133 15.1107 11.0014 13.1532 10.0286C14.7534 8.28555 14.6375 5.57535 12.8944 3.97522C11.1514 2.3751 8.44117 2.49099 6.84104 4.23404C5.33677 5.8727 5.33677 8.38998 6.84104 10.0286C4.88361 11.0014 3.47624 12.8133 3.01802 14.9505C0.27991 11.0937 1.18681 5.74744 5.04365 3.00933C8.90048 0.271226 14.2467 1.17813 16.9848 5.03496C18.0141 6.48481 18.5666 8.21907 18.5658 9.99714C18.5658 11.7737 18.01 13.5057 16.9763 14.9505Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </IonRouterLink>
          </li>

          {/* <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() =>
          setShowPopover({ showPopover: false, event: undefined })
        }
        trigger={popoverTrigger}
        ref={ionPopoverRef}
        size="cover"
        id="login-popover"
        reference="trigger"
        triggerAction="click"
        side="bottom"
        showBackdrop={false}
        style={{
          "--offset-y": "10px",
          "--min-width": "245px",
        }}
      >
        
      </IonPopover> */}
        </ul>
        {/* Toggler */}
        <button
          className="navbar-toggler ms-4 ms-md-5 shadow-none bg-teal text-white icon-xs p-0 outline-0 h-40p w-40p d-flex d-xl-none place-flex-center"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          {/* Icon */}
          <svg
            width={25}
            height={17}
            viewBox="0 0 25 17"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width={25} height={1} fill="currentColor" />
            <rect y={8} width={15} height={1} fill="currentColor" />
            <rect y={16} width={20} height={1} fill="currentColor" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default CustomerHeaderDesktop;
